"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const zoomout = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-zoomout` : '') + (description ? ` desc-zoomout` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-zoomout"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-zoomout"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_2028)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.81329 0C15.2324 0 19.6257 4.39277 19.6263 9.81192C19.6266 12.2054 18.7573 14.4569 17.263 16.2004L23.7817 22.7197C24.0745 23.0126 24.0745 23.4875 23.7816 23.7804C23.5153 24.0466 23.0986 24.0708 22.805 23.8529L22.7209 23.7803L16.2024 17.2617C15.4289 17.9253 14.5442 18.4748 13.5693 18.8787C9.90248 20.3979 5.68155 19.5586 2.87483 16.7522C0.0681081 13.9458 -0.771649 9.72498 0.747154 6.05798C2.26596 2.39098 5.8442 0 9.81329 0ZM9.81329 1.5C6.45091 1.5 3.41963 3.5255 2.13299 6.63196C0.846348 9.73843 1.55774 13.3141 3.93543 15.6915C6.31312 18.0689 9.88884 18.7799 12.9952 17.4929C16.1015 16.206 18.1267 13.1745 18.1263 9.81208C18.1258 5.2213 14.4041 1.5 9.81329 1.5ZM14.2513 9C14.6655 9 15.0013 9.33579 15.0013 9.75C15.0013 10.1297 14.7191 10.4435 14.3531 10.4932L14.2513 10.5H5.25129C4.83707 10.5 4.50129 10.1642 4.50129 9.75C4.50129 9.3703 4.78344 9.05651 5.14952 9.00685L5.25129 9H14.2513Z",
    fill: "inherit"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_2028"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = zoomout;